export interface Bank {
  id: string;
  name: string;
  bestFor: string;
  perk: string;
  image: string;
  /**
   * Blue glow bleeding across the image's left edge. Only the Airwallex card
   * carries one in the design, so it's a per-bank flag rather than baked into
   * the card.
   */
  imageGlow?: boolean;
  /** Powers the "Why founders choose …" panel; only Airwallex's are designed. */
  reasons: string[];
}

/** Banking is perk-based, so none of this feeds the package total. */
export const BANKS: Bank[] = [
  {
    id: "aspire",
    name: "Aspire",
    bestFor: "Best For: Growing Teams & SaaS",
    perk: "HK$2,000 Welcome Cashback",
    image: "/get-started/aspire.svg",
    reasons: [],
  },
  {
    id: "airwallex",
    name: "Airwallex",
    bestFor: "Best For: eCommerce & Global Trade",
    perk: "HK$100,000 Fee-Free FX",
    image: "/get-started/airwallex.svg",
    imageGlow: true,
    reasons: [
      "Receive HKD, USD, EUR, GBP locally.",
      "Accept credit cards & 160+ pay methods.",
      "Uncapped 1% back on card spending.",
      "Rates as low as 0.2% above interbank.",
    ],
  },
];
